import { BrandLockup } from './brand-lockup'
import { ThemeToggle } from './theme-toggle'
import { DOMAINS } from '../lib/taxonomy'

const current = (prefix: string) =>
  typeof window !== 'undefined' && (window.location.pathname === prefix || window.location.pathname.startsWith(`${prefix}/`))

export function SiteHeader() {
  return (
    <header className="site-header">
      <div className="container site-nav">
        <a className="wordmark" href="/" aria-label="NearMetal home">
          <BrandLockup />
        </a>
        <nav className="nav-links" aria-label="Primary navigation">
          <a href="/jobs" aria-current={current('/jobs') ? 'page' : undefined}>Jobs</a>
          <a href="/companies" aria-current={current('/companies') ? 'page' : undefined}>Companies</a>
          <a href="/reports" aria-current={current('/reports') ? 'page' : undefined}>Reports</a>
          <a href="/newsletter" aria-current={current('/newsletter') ? 'page' : undefined}>Weekly</a>
          <a href="/about" aria-current={current('/about') ? 'page' : undefined}>About</a>
          <a className="nav-keep" href="/post-a-job">Post a job</a>
        </nav>
        <ThemeToggle />
      </div>
    </header>
  )
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <a className="wordmark" href="/" aria-label="NearMetal home">
            <BrandLockup />
          </a>
          <p className="job-meta mt-4 max-w-md">
            An index of systems software roles taken from company career sources. NearMetal is not the employer and does not accept applications.
          </p>
        </div>
        <div className="footer-links" aria-label="Explore">
          <strong>Index</strong>
          <a href="/jobs">All roles</a>
          <a href="/jobs/remote">Remote roles</a>
          <a href="/companies">Companies hiring</a>
          <a href="/reports">Hiring reports</a>
        </div>
        <div className="footer-links" aria-label="Sub-domains">
          <strong>Sub-domains</strong>
          {DOMAINS.slice(0, 4).map((domain) => (
            <a href={`/jobs/${domain.slug}`} key={domain.code}>{domain.heading.replace(/ Jobs$/, '')}</a>
          ))}
        </div>
        <div className="footer-links" aria-label="Company">
          <strong>Site</strong>
          <a href="/about">About and contact</a>
          <a href="/status">Index status</a>
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
        </div>
      </div>
    </footer>
  )
}
